import { getSerializer } from '@shared/serializers/serializer';

export const librariesCategory = {
  type: 'librarycategory',
  attributes: [
    'name',
  ],
};

export const LibrariesCategorySerializer = getSerializer(librariesCategory);
